import React from 'react';

import CampaignActions from './components/CampaignActions';
import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import EmptyState from 'src/presentation/components/pages/proactiveCommunications/components/shared/EmptyState';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import ProactiveCommunication from 'src/presentation/components/pages/proactiveCommunications/components/ProactiveCommunications';

const ProactiveVoice = ({ root }) => {
  const description = (
    <span>
      Proactively reach out to your customers through automated phone calls. Visit our{' '}
      <ExternalLink
        data-aid="set-up-proactive-voice-help-link"
        label="Help Docs"
        to="https://help.gladly.com/docs/what-is-proactive-voice"
      />{' '}
      to learn about Voice Campaigns.
    </span>
  );

  const actions = <CampaignActions root={root} />;
  const emptyStateRender = <EmptyState title="Create your first Proactive Voice Campaign" actionsRender={actions} />;

  return (
    <ProactiveCommunication
      actionsRender={actions}
      campaignType={CampaignType.VOICE}
      description={description}
      header="Proactive Voice"
      root={root}
      emptyStateRender={emptyStateRender}
    />
  );
};

export default ProactiveVoice;
